export default __webpack_public_path__ + "static/media/1_10.cd5edec4.png";